import { useEffect } from "react";
import { Crisp } from "crisp-sdk-web";

/**
 * CrispChat Component
 * 
 * Initializes and manages the Crisp chat widget.
 * The website ID is read from the VITE_CRISP_WEBSITE_ID environment variable.
 * 
 * Usage:
 * - Add <CrispChat /> to your main layout
 * - Set VITE_CRISP_WEBSITE_ID in your .env file
 */
const CrispChat = () => {
  useEffect(() => {
    const websiteId = import.meta.env.VITE_CRISP_WEBSITE_ID;

    if (!websiteId) {
      console.warn(
        "Crisp chat is not configured. Please set VITE_CRISP_WEBSITE_ID in your environment variables."
      );
      return;
    }

    // Configure Crisp with the website ID
    Crisp.configure(websiteId);

    // Optional: Configure additional settings
    // Crisp.session.setData("key", "value");
    // Crisp.session.setSegment("segment-name");

    // Cleanup function (though Crisp doesn't require explicit cleanup)
    return () => {
      // Crisp SDK handles cleanup automatically
    };
  }, []);

  // This component doesn't render anything visible
  // The Crisp widget is injected into the DOM by the SDK
  return null;
};

export default CrispChat;

